export default __webpack_public_path__ + "static/media/Ballroll_00290.9969d32d.png";